import _ from "lodash";

export const VADEMECUM = "vademecum";
export const MANUAL = "manual";

export const PRESCRIPTION_METHOD_OPTIONS = [
  { label: "Vademecum", value: VADEMECUM },
  { label: "Manual", value: MANUAL },
];

/**
 * Methods a user may pick in the new-prescription form. `prescriptionMethods` comes from api's
 * user JSON; a user without the field (older api) keeps every option.
 */
export const availablePrescriptionMethods = (prescriptionMethods) =>
  _.isNil(prescriptionMethods)
    ? PRESCRIPTION_METHOD_OPTIONS
    : _.filter(PRESCRIPTION_METHOD_OPTIONS, ({ value }) => _.includes(prescriptionMethods, value));

export const canPrescribeFrom = (prescriptionMethods, method) =>
  _.isNil(prescriptionMethods) || _.includes(prescriptionMethods, method);

export const hasVademecumMedicines = (medicines) =>
  _.some(medicines, (medicine) => !_.isEmpty(medicine?.externalId));
